import { render, staticRenderFns } from "./BaseResourceList.vue?vue&type=template&id=ad6aa188&scoped=true&"
import script from "./BaseResourceList.vue?vue&type=script&lang=js&"
export * from "./BaseResourceList.vue?vue&type=script&lang=js&"
import style0 from "./BaseResourceList.vue?vue&type=style&index=0&id=ad6aa188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6aa188",
  null
  
)

export default component.exports